module.exports = __webpack_public_path__ + "img/BAU Seniors_25.27e914e7.jpg";